<template>
    <button class="p-link layout-topbar-button" @click="changeTheme">
        <i class="pi" :class="themes[currentThemeIndex].icon" />
    </button>
</template>

<script setup lang="ts">
    import { type Ref, onMounted, ref, watch } from 'vue'

    import { useLayout } from '@/layouts/layout'
    import { useAppStore } from '@/stores/app'

    interface ThemeSwitcherTheme {
        name: string
        icon: string
    }

    // data
    const { changeThemeSettings } = useLayout()
    const theme: Ref<string> = ref('')
    const currentThemeIndex: Ref<number> = ref(0)
    const themes: ThemeSwitcherTheme[] = [
        {
            name: 'light',
            icon: 'pi-sun'
        },
        {
            name: 'dark',
            icon: 'pi-moon'
        }
    ]

    // methods
    const changeTheme = () => {
        theme.value = theme.value === 'light' ? 'dark' : 'light'
        changeThemeSettings(theme.value)
        useAppStore().setTheme(theme.value)
    }

    // watcher
    watch(theme, (value) => {
        const index = themes.findIndex(x => x.name === value)
        currentThemeIndex.value = index > -1 ? index : 0
    })

    // hook
    onMounted(() => {
        theme.value = localStorage.getItem('theme') ?? 'light'
        useAppStore().setTheme(theme.value)
    })
</script>
